import { useState } from 'react';
import JsonLd from '@/components/base/JsonLd';

const faqItems = [
  {
    question: '逼特逼视频是什么？有哪些核心功能？',
    answer: '逼特逼视频是一个综合性视频内容平台，提供海量优质视频资源。核心功能包括：个性化内容推荐、高清视频播放（支持4K）、离线下载、弹幕互动、视频创作工具、直播功能以及社交分享等。平台覆盖娱乐搞笑、教程学习、科技数码、生活记录、音乐舞蹈、体育竞技、游戏电竞、新闻资讯等八大内容领域。',
  },
  {
    question: '如何下载和使用逼特逼视频APP？',
    answer: '您可以在逼特逼视频官网首页找到APP下载入口，支持iOS和Android两大平台。扫描二维码或点击下载链接即可跳转到对应应用商店。下载安装后，使用手机号或邮箱注册账号即可开始使用。APP支持离线下载、投屏播放、省流模式等特色功能。',
  },
  {
    question: '逼特逼视频的内容推荐机制是怎样的？',
    answer: '逼特逼视频采用先进的机器学习算法，综合分析您的观看历史、搜索记录、互动行为（点赞、评论、收藏）等多维度数据，为您提供个性化的内容推荐。您可以通过使用"不感兴趣"功能、主动搜索感兴趣的关键词、完播喜爱内容等方式来优化推荐结果。',
  },
  {
    question: '逼特逼视频平台是否免费使用？',
    answer: '逼特逼视频基础功能完全免费，包括视频观看、评论互动、内容分享等。平台也提供会员服务，会员用户可享受无广告观看、超清画质、专属内容、优先体验新功能等特权。您可以根据个人需求选择免费使用或开通会员。',
  },
  {
    question: '如何在逼特逼视频上发布自己的视频内容？',
    answer: '注册账号并完成实名认证后，点击APP或网页端的"发布"按钮即可上传视频。平台内置视频编辑器，支持剪辑、添加滤镜、字幕和背景音乐等功能。发布时请确保内容遵守平台社区规范，选择合适的内容分类和标签有助于获得更多曝光。',
  },
  {
    question: '逼特逼视频如何保障用户隐私和账号安全？',
    answer: '逼特逼视频采用先进的加密技术保障用户数据安全。您可以在隐私设置中管理视频可见范围、评论权限、私信权限等。平台还提供双重认证功能，建议用户开启以增强账号安全性。我们严格遵守相关法律法规，不会未经授权向第三方透露用户个人信息。',
  },
  {
    question: '逼特逼视频支持哪些设备观看？',
    answer: '逼特逼视频支持多端观看，包括：网页端（所有主流浏览器）、移动端（iOS和Android APP）、平板设备以及智能电视。移动端APP提供最佳观看体验，支持离线下载、投屏播放等功能。平台会自动适配不同设备的屏幕尺寸，确保流畅的观看体验。',
  },
  {
    question: '遇到播放问题或内容投诉应该怎么办？',
    answer: '如果您遇到视频无法播放、卡顿等技术问题，建议先检查网络连接并尝试切换清晰度。如问题仍未解决，可通过APP内"设置-帮助与反馈"提交问题。对于内容投诉，可通过视频下方的"举报"功能进行反馈，我们的审核团队会及时处理并回复。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于逼特逼视频的常见疑问，这里都有答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-heading font-bold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-lg text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-4 md:pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-4 md:px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <JsonLd type="FAQPage" faqData={faqItems.map((f) => ({ question: f.question, answer: f.answer }))} />
      </div>
    </section>
  );
}